/**
 * Lyra Therapy (LT) Therapist role configurations.
 */

import {
  BC_DBT_TEENS_THERAPIST_CALENDAR,
  BC_DBT_THERAPIST_CALENDAR,
  BC_THERAPIST_CALENDAR,
  MINIMAL_CALENDAR,
} from './calendars'
import { RoleConfig } from './types'

/**
 * LT Therapist configuration.
 */
export const LT_THERAPIST: RoleConfig = {
  sameDayBooking: true,
  bcPlatform: true,
  showOOOMessageTab: true,
  videoSessionsEnabled: true,
  medicationEnabled: false,
  zendeskWidget: false,
  requestPayment: false,
  directAccessClientList: false,
  helpCenterUrl: 'https://bct-lyrahealth.zendesk.com/hc/en-us',
  eligibilityChecker: false,
  utilizationEnabled: true,
  showMinifiedUtilization: false,
  showOverdueMessageFlag: false,
  showInPersonPrompt: false,
  smartSchedulingEnabled: false,
  hidePerformanceMetrics: false,
  showCloseSessionBanner: true,
  inProductCalendar: BC_THERAPIST_CALENDAR,
  showCareInsights: true,
}

/**
 * LT Fellow Therapist configuration.
 * Similar to LT Therapist but with overdue message flag enabled.
 */
export const LT_FELLOW_THERAPIST: RoleConfig = {
  ...LT_THERAPIST,
  showOverdueMessageFlag: true,
  showCareInsights: true,
  inProductCalendar: {
    ...BC_THERAPIST_CALENDAR,
    showCalendarPopupReschedule: undefined,
    showCalendarPopupCancel: undefined,
    showCalendarPopupClose: undefined,
  },
}

/**
 * LT DBT configuraion
 * Used by: LT_DBT_THERAPIST
 */
export const LT_DBT_THERAPIST: RoleConfig = {
  ...LT_THERAPIST,
  sameDayBooking: false,
  assessmentTrackSettingsEnabled: true,
  inProductCalendar: BC_DBT_THERAPIST_CALENDAR,
  medicationEnabled: true,
}

/**
 * LT DBT Teens configuration
 * Used by: LT_DBT_TEENS_THERAPIST
 */
export const LT_DBT_TEENS_THERAPIST: RoleConfig = {
  ...LT_THERAPIST,
  sameDayBooking: false,
  assessmentTrackSettingsEnabled: true,
  inProductCalendar: BC_DBT_TEENS_THERAPIST_CALENDAR,
  medicationEnabled: true,
  openClientAccessSupported: true,
}

/**
 * LT Supervisor configuration.
 * Used by: LT_SUPERVISOR, LT_FELLOW_SUPERVISOR, LT_TEENS_THERAPIST_SUPERVISOR, LT_AUD_THERAPIST_SUPERVISOR
 */
export const LT_SUPERVISOR: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: false,
  assessmentTrackSettingsEnabled: true,
  inProductCalendar: MINIMAL_CALENDAR,
}
